/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BaseCostProcessingPeriodMemory extends models.BillingPeriodInformation {
    getFixupPrototypeFunction() { return BaseCostProcessingPeriodMemory.fixupPrototype; }

    static newInstance(model: Partial<BaseCostProcessingPeriodMemory>): BaseCostProcessingPeriodMemory {
        let obj = Object.assign(new BaseCostProcessingPeriodMemory(), model);
        BaseCostProcessingPeriodMemory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BaseCostProcessingPeriodMemory>): BaseCostProcessingPeriodMemory {
        if (!model) return null;
        return BaseCostProcessingPeriodMemory.newInstance(<BaseCostProcessingPeriodMemory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BaseCostProcessingPeriodMemory) {
        if (!obj) return;

        models.BaseCostProcessingPeriodMemory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BaseCostProcessingPeriodMemory): boolean {
        if (models.BillingPeriodInformation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BaseCostProcessingPeriodMemory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.processed_line_items === undefined) {
            this.processed_line_items = 0;
        }
        if (typeof this.last_refreshed_at === "string") {
            this.last_refreshed_at = new Date(<string><any>this.last_refreshed_at);
        }
    }

    /**
     * Number of processed line items
     */
    processed_line_items: number;

    /**
     * The date of last refresh of billing period
     */
    last_refreshed_at: Date;

}
